export const DEFAULT_STAY_CANCELLATION_POLICY =
  'Free cancellation until 24 hours before check-in. Cancellations made within 24 hours of check-in will be charged 50% of the total booking amount.';

/** Resolve cancellation copy from stay / property payload (direct field or house rule). */
export function resolveStayCancellationPolicy(source) {
  if (!source) return null;
  const direct = source.cancellationPolicy && String(source.cancellationPolicy).trim();
  if (direct) return direct;

  const rules = source.houseRules || [];
  const match = rules.find((rule) => /cancellation/i.test(rule?.ruleName || ''));
  const fromRule = match?.ruleValue && String(match.ruleValue).trim();
  return fromRule || null;
}

export function getStayCancellationPolicyText(source) {
  return resolveStayCancellationPolicy(source) || DEFAULT_STAY_CANCELLATION_POLICY;
}
